var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMarketplace = function SvgMarketplace(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    fill: "none",
    viewBox: "0 0 106 106",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M43.862 78.586h18.276V98.69H43.862V78.586z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDD1F2",
    d: "M53 89.552c-1.01 0-1.828-.819-1.828-1.828v-9.138c0-1.01.819-1.827 1.828-1.827 1.01 0 1.828.818 1.828 1.827v9.138c0 1.01-.819 1.828-1.828 1.828z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 63.965,
    y: 14.621,
    fill: "#D3ECFF",
    rx: 4.711
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M38.38 98.69h29.24V106H38.38v-7.31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M20.104 14.62h65.793v43.863H20.103V14.62z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC431",
    d: "M20.104 14.62h10.965v5.484c0 3.027-2.455 5.482-5.483 5.482-3.028 0-5.482-2.454-5.482-5.482V14.62z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M31.069 14.62h10.966v5.484c0 3.027-2.455 5.482-5.483 5.482-3.028 0-5.483-2.454-5.483-5.482V14.62z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC431",
    d: "M42.035 14.62H53v5.484c0 3.027-2.455 5.482-5.483 5.482-3.028 0-5.483-2.454-5.483-5.482V14.62z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M53 14.62h10.965v5.484c0 3.027-2.454 5.482-5.482 5.482S53 23.132 53 20.104V14.62z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC431",
    d: "M63.965 14.62h10.966v5.484c0 3.027-2.455 5.482-5.483 5.482-3.028 0-5.482-2.454-5.482-5.482V14.62z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M74.931 14.62h10.966v5.484c0 3.027-2.455 5.482-5.483 5.482-3.028 0-5.483-2.454-5.483-5.482V14.62z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M62.138 32.897h14.62v25.586h-14.62V32.897zM29.241 32.897H53v16.448H29.241V32.897z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C6EB",
    d: "M67.62 47.517c1.01 0 1.828-.818 1.828-1.827 0-1.01-.818-1.828-1.827-1.828-1.01 0-1.828.818-1.828 1.828 0 1.009.818 1.827 1.828 1.827z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M31.069 14.62L38.379 0H27.414l-7.31 14.62h10.965z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M42.035 14.62L49.345 0H38.379l-7.31 14.62h10.966z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M53 14.62L60.31 0H49.345l-7.31 14.62H53z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M63.965 14.62L71.275 0H60.31L53 14.62h10.965z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB401",
    d: "M80.414 3.655L74.93 14.621H63.966L71.275 0h7.31l1.828 3.655z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA100",
    d: "M85.897 14.62H74.93l5.483-10.965 5.483 10.966z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDD1F2",
    d: "M9.138 56.655h87.724v3.655H9.138v-3.655z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarketplace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marketplace.e0c547b2.svg";
export { ForwardRef as ReactComponent };